import { Product, ProductAddon, ProductDetail, ProductStore } from '../models/interfaces-general';
import { ProductoComplementoApi, ProductoDetalleApi, ProductoListApi } from '../models/api/producto-api';
import { Constante } from '../../constante';

export class ProductoMapper {
    static toCarousel(item: ProductoListApi): Product {
        const images = ProductoMapper.imagenes(item);
        return {
            id: item.uuid,
            name: item.nombre,
            images,
            originalPrice: item.precioOferta != null ? item.precio : undefined,
            discountPrice: item.precioFinal,
            discountPercentage: item.porcentajeDescuento ?? undefined,
            currency: 'S/',
            url: `${Constante.URL_PRODUCTO}/${item.slug ?? item.uuid}`
        };
    }

    static toStore(item: ProductoListApi): ProductStore {
        const images = ProductoMapper.imagenes(item);
        return {
            id: item.uuid,
            title: item.nombre,
            price: item.precioFinal,
            imageUrl: images[0] ?? '',
            images,
            badgeText: item.esNuevo
                ? 'Nuevo'
                : item.porcentajeDescuento
                    ? `-${item.porcentajeDescuento}%`
                    : undefined,
            badgeType: item.esNuevo ? 'new' : item.porcentajeDescuento ? 'discount' : undefined,
            targetUrl: `${Constante.URL_PRODUCTO}/${item.slug ?? item.uuid}`
        };
    }

    static toDetail(item: ProductoDetalleApi): ProductDetail {
        const images = (item.imagenes ?? [])
            .map((img) => img.urlMedium || img.urlOriginal)
            .filter((url): url is string => !!url);

        return {
            id: item.uuid,
            title: item.nombre,
            price: item.precioFinal,
            images,
            sku: item.sku,
            inStock: item.stockDisponible > 0,
            descriptionHtml: item.descripcion ?? undefined,
            specifications: undefined
        };
    }

    private static imagenes(item: ProductoListApi): string[] {
        const lista = (item.urlImagenes ?? []).filter((url): url is string => !!url);
        if (lista.length > 0) {
            return lista;
        }
        return [item.urlImagen, item.urlImagenHover].filter((url): url is string => !!url);
    }

    static toAddon(item: ProductoComplementoApi): ProductAddon {
        return {
            id: item.uuid,
            name: item.nombre,
            price: item.precio,
            imageUrl: item.urlImagen || ''
        };
    }
}
